import { ReactComponent as LogoutSVG } from "./Logout.svg";
import { SvgIcon } from '@mui/material';

export default function IconLogout(props) {
  return <SvgIcon {...props} component={LogoutSVG} viewBox="0 0 28 24" />;
}